export default __webpack_public_path__ + "static/media/politicaCalitate.a1566558.pdf";